import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var useSearchOffers = function () {
    return useApiCall(function (signal, payload) { return api.offer.apiOfferDataSearchPost(payload, { signal: signal }); }, [], true, [], { error: 'Failed to fetch offers' });
};
